import { Typography } from "@outschool/backpack";
import { ActivityListing_ListingFragment } from "@outschool/gql-frontend-generated";
import { Container, Space } from "@outschool/ui-legacy-component-library";
import React from "react";

import { MobileListing } from "./MobileListing";

type MobileActivityListComponentProps = {
  lists: ActivityListing_ListingFragment[];
  pageLocation: string;
  title: string;
};
export const MobileActivityListComponent = ({
  lists,
  pageLocation,
  title
}: MobileActivityListComponentProps) => (
  <>
    <Container>
      <Space y={40} />
      <Typography emphasized variant={"h6"}>
        {title}
      </Typography>
    </Container>
    <>
      {lists.map(list => (
        <MobileListing
          key={list.activity.uid}
          activity={list.activity}
          nextSection={list.nextSection}
          leader={list.leader}
          trackingProperties={{
            order: list.activity.uid,
            activity_title: list.activity.title
          }}
          insertionId={list.insertionId}
          disabled={false}
          listingIndex={1}
          pageLocation={pageLocation}
        />
      ))}
    </>
  </>
);
